// extracted by mini-css-extract-plugin
module.exports = {"root":"DatePicker_root__2T0vX","day":"DatePicker_day__3uqRd"};